import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import categoryImg from './../../../images/category-img.png';
import houseIcon from './../../../images/house-icon.png';
import template from './sub-category.html';

@Component({
  controllerAs: 'subCategory',
  template
})

export default class SubCategory {
  static $inject = [
      '$rootScope',
    '$scope',
    '$ngRedux',
    '$stateParams',
    'toaster',
    '$state',
    'orderService',
    'spinnerService',
    'orderActions',
    'authService',
    '$window',
    'APP',
    '$location',
    'ngMeta' 
  ];

  constructor($rootScope,$scope, $ngRedux, $stateParams, $toaster, $state, $order, $spinner, orderActions, $auth, $window, APP, $location, ngMeta) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.categoryImg = categoryImg;
    this.$toaster = $toaster;
    this.$state = $state;
    this.$auth = $auth;
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.storeName = '';
    this.$window = $window;
    this.APP = APP;
    this.$location = $location;
    this.ngMeta = ngMeta;
    $ngRedux.dispatch(orderActions.setSubCategories({subCategories: []}));
    this.$spinner = $spinner;
    this.$spinner.show('appSpinner');
    if(this.$auth.isLoggedIn() || this.$auth.isGuestLogin())
    {
      if(this.list.length == 0) {
      this.loadSubCategories();
      }
    } 
    else {
      if(this.list!=null){
        if(this.list.length == 0) {
          setTimeout(() => {
            this.loadSubCategories();
          }, 2000);
          }
      }
    }
    if(this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      // this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') +'/' +this.APP.ORDER.ORDER_URL.browseUrl +'/' + this.$stateParams.categoryId;
      this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') +'/' +this.$stateParams.storeName +'/' + this.$stateParams.categoryId;
    } 
    else{
      this.canUrl = this.$location.$$absUrl;
    }
    // console.log("this.canUrl.subcategory : ",this.canUrl);
    this.ngMeta.setTag('canUrl',this.canUrl);
    // var listener1 =  $rootScope.$on('onGuestLogin', () => this.loadSubCategories());
    $scope.$on('$destroy', () => {
    disconnect();
    // if(this.list.length == 0) {
    //   listener1();
    // }
  });
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      list: state.order.subCategories
    };
  }


  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');
    }
  }
 

  loadSubCategories() {
    if(this.profile.store && this.profile.store.storeName) {
      this.storeName = this.profile.store;
    } else {
      this.storeName = this.$auth.getGuestStoreDetail().storeName;
    }
    
    this.$order.getSubCategories(this.$stateParams.categoryId)
        .then(success => {
          
          
      if (!success.data.subCategories.length) {
      this.$toaster.pop('success', 'Sorry, There are no products currently');
      this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName});
    }
    else {
      this.ngMeta.setTitle(success.data.subCategories[0].category.name);
      this.ngMeta.setTag('description',success.data.subCategories[0].category.description? success.data.subCategories[0].category.description : 'Product Page description');
      this.ngMeta.setTag('image',success.data.subCategories[0].category.smallImageUrl);
      this.ngMeta.setTag('alt',success.data.subCategories[0].category.alt ? success.data.subCategories[0].category.alt : 'Product Image');
 
      this.$window.document.title = success.data.subCategories[0].category.title ? ( success.data.subCategories[0].category.title  + ' | Wild Birds Unlimited' ) : this.APP.ORDER.ORDER_URL.siteTitle;
    }
  })
  .finally(() => this.$spinner.hide('appSpinner'));
  }

  goToNextState(item) {
    let storeName = '';
    if(this.$stateParams.storeName) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if(this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
       storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    // let storeName =  false;
    if (storeName) {
      this.$state.go('browse-product', {
        subCategoryId: item.prettyUrl
       });
    }
    else {
      this.$state.go('browse-product', {
        subCategoryId: item.prettyUrl
       });
    }
  }

  getImageUrl(subCategory) {
    if (window.innerWidth < 768) {
      return subCategory.mediumImageUrl;
    }
    else {
      return subCategory.largeImageUrl;
    }
  }
  getImageTitle(subCategory) {
    if (subCategory.alt) {
      return subCategory.alt;
    }
    else {
      return 'Wild Birds Unlimited';
    }
  }
  isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

}



// WEBPACK FOOTER //
// ./src/app/order/sub-category/sub-category.js